import React, {useCallback, useEffect, useState} from 'react';

import {DATE_FORMAT_URL} from '../../../../../data/constants/datetime';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {eventMomentFactory} from '../../../../../data/misc/eventMomentFactory';
import {useInterval} from '../../../../../misc/hooks';
import flexStyles from '../../../../../style/flex-animation.module.scss';
import Link from '../../../../elements/Link';
import RoundImage from '../../../../elements/RoundImage';
import SpeakerDetails from './innerComponents/SpeakerDetails';

import stylesheet from './WaitingRoomSpeaker.module.scss';

const WaitingRoomSpeaker = props => {
    const {event, session} = props,
        {speakers} = session,
        [visible, setVisible] = useState(false),
        i18n = useI18n(),
        [position, setPosition] = useState(0),
        [animated, setAnimated] = useState(true),
        speakerCount = speakers.length || 0;

    useInterval(
        () => {
            const nextPos = position + 1 < speakerCount ? position + 1 : 0;
            setPosition(nextPos);
        },
        animated && speakerCount > 1 ? 8000 : null
    );

    useEffect(() => {
        // visible only when there are speakers and waiting room stream is not available
        setVisible(speakerCount > 0 && !(session?.waiting_room_stream_url && session?.waiting_room_stream_enabled));
    }, [session]);

    const handleMouseEnter = useCallback(() => setAnimated(false), []),
        handleMouseLeave = useCallback(() => setAnimated(true), []);

    return (
        <div
            className={['WaitingRoomSpeaker', 'text-center', flexStyles.col, visible ? flexStyles.visible : flexStyles.hidden].join(' ')}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}>
            <h2>{i18n['label.speakers']}</h2>
            <div className={stylesheet.speakerWrapper}>
                {speakers.map((speaker, i) => (
                    <SpeakerDetails
                        key={speaker.id}
                        className={i < position ? 'left' : i > position ? 'right' : 'focus'}
                        event={event}
                        speaker={speaker}
                        session={session}
                    />
                ))}
            </div>
        </div>
    );
};

export default WaitingRoomSpeaker;
